import { ActionItems } from "components/HomeActionItems/HomeActionItems";
import React from "react";

export const BooksTodos = ({
  selectedStatusTab,
}: {
  selectedStatusTab: "REQUESTED" | "DEPRECATED" | "SUBMITTED";
}) => {
  return <ActionItems isGroupBased selectedStatusTab={selectedStatusTab} />;
};
